<template lang="pug">
  .takeawayTwoSlide.grey-background(ref="takeawayTwo")
    .max-width-grid
      h4.black.title Takeaways for organizing product descriptions<span class="super"> 11</span>
      .wrapper
        p Use <span class="bold">full sentences</span> for longer product<br>descriptions to drive higher add-to-cart rates.
        TakeawayTwo
        .text-block
          h4.black The Perfect Sleigh
          p For all of your picturesque winter sleigh rides, this antique-designed wooden sleigh combines beauty with performance. From sliding down hill to bringing home your holiday haul, this handmade sleigh can support all your holiday activities.
</template>

<script>
import TakeawayTwo from '@/assets/img/svgs/takeawayTwo.svg'

export default {
  name: 'takeawayTwoSlide',
  props: {
  },
  data () {
    return {
    }
  },
  mounted () {
    const cursor = this.$el.querySelector('.cursor')
    const stars = this.$el.querySelectorAll('.star')
    this.timeline = new TimelineLite({ paused: true })

    stars.forEach((star, i) => {
      this.timeline
        .from(star, .2, { transformOrigin: '50% 50%', opacity: 0, scale: .85, rotation: i%2 === 0 ? 30 : -30 }, i/2)
    })
    
    this.timeline
      .fromTo(cursor, .5, { opacity: 0, y: 30, x: 30 }, { opacity: 1, y: 0, x: 0 })
  },
  computed: {
  },
  methods: {
    playAnimation () {
      this.timeline.seek(0)
      this.timeline.play()
    },
  },
  components: {
    TakeawayTwo,
  },
}
</script>

<style scoped lang="scss">
.takeawayTwoSlide {
  height: 63rem;
  padding-top: 5rem;

  .title,
  svg {
    text-align: center;
  }

  .title {
    padding-bottom: 3.5rem;
  }

  .wrapper {
    width: 62%;
    margin: 0 auto;
  }

  .text-block {
    left: 46.5%;
    top: 40.5%;
    h4 {
      padding-bottom: 2.6rem;
    }
    p {
      width: 29rem;
    }
  }

  @media #{$mobile} {
    .text-block {
      left: 45.5%;
      top: 42%;
      p {
        width: 35rem;
      }
    }
    p {
      font-size: 1.9rem;
      line-height: 2.2rem;
      margin-bottom: .9rem;
    }
    .wrapper {
      width: 68%;
    }
  }
}
</style>
